// extracted by mini-css-extract-plugin
export default {"tag":"tag--IPboe","text":"text--Xh8MT","primary":"primary--VmT0z","secondary":"secondary--SQ_an","closeButton":"closeButton--gK1vA"};